module.exports = __webpack_public_path__ + "img/c_bg2.2ee223f3.jpg";